// MEGA MENU

let subitems_menu_container = document.querySelector('.mega-menu__columns-wrapper');
let subitems_menu = document.querySelectorAll('.mega-menu__column .mega-menu__title');
let sliders_container = document.querySelector('.mega-menu__slider-container');

// Add class "selected" on the link in the div "mega-menu__column" in the subitems_menu_container
subitems_menu_container.firstElementChild.classList.add('selected');

// Add class "active" on the first slider in the container 
sliders_container.firstElementChild.classList.add('active');
sliders_container.firstElementChild.style.display = "flex";
subitems_menu.forEach(function (subitem_menu) {
  subitem_menu.addEventListener('click', function (e) {
    e.preventDefault();

    // Remove and add class "selected" on the elements
    let subitem_selected = document.querySelector('.mega-menu__column.selected');
    subitem_selected.classList.remove('selected'); // Remove class from old link
    subitem_menu.closest('.mega-menu__column').classList.add('selected'); // Add class to the clicked link

    // Get the data-id of the link
    let subitem_data_id = subitem_menu.getAttribute('data-id');

    // Find the slider which matched with the data-id of the link
    let slider_matched = document.querySelector(`.mega-menu__slider-container flickity-carousel[data-target="${subitem_data_id}"]`);

    // Remove class active from slider displayed
    let slider_active = document.querySelector('.mega-menu__slider-container flickity-carousel.active');
    slider_active.classList.remove('active');
    setTimeout(() => {
      // Add class "active" on the new slider
      console.log("1/2 SECONDES PLUS TARD");
      slider_active.style.display = "none";
      slider_matched.style.display = "flex";
      slider_matched.classList.add('active');
    }, 200);
  });
});

// CONTACT PAGES
// Get the object of the message and select the correct object in the form
window.addEventListener('load', function () {
  setTimeout(function () {
    // GET THE OBJECT PARAMS IN THE URL (object of the link clicked before)
    let url = new URL(window.location); // Get the url
    let params = url.searchParams; // Get the params of the URL
    let object = params.get('object'); // Get the "object" params of the url

    // GET THE OBJECTS OF THE CONTACT FORM AND CHECK IF ONE IS MATCHING OBJECT PARAMS
    let options = document.querySelectorAll('select[name="object"] option');

    /*     options.forEach(function(option){
          let value = option.getAttribute('value').replaceAll(' ', '-').toLowerCase();
          console.log("value : " + value);
          console.log("object : " + object);
    
          if(value == object){
            option.setAttribute('selected', 'selected'); // Add selected=selectd attribute on the matching option
            return;
          }
        }); */

    for (let i = 0; i < options.length; i++) {
      let value = options[i].value.toLowerCase().replaceAll('’', '-').replace("'", '').replaceAll(' ', '-').replaceAll('à', 'a').replaceAll('é', 'e').replaceAll('è', 'e').replaceAll('ù', 'u');
      console.log(value);
      console.log(object);
      if (value == object) {
        options[i].setAttribute('selected', 'selected');
        break;
      }
    }

    // INPUT FILE
    // Display file name after it has been selected
    let inputFile = document.querySelector('.fileOuterCS input[type="file"]');
    let inputFileLabel = document.querySelector('.fileOuterCS label');
    if (inputFile != undefined) {
      inputFile.addEventListener('change', function () {
        let fileName = inputFile.files[0].name;
        inputFileLabel.innerHTML = fileName;
      });
    }
  }, 500);
});

// Form show/hide password
document.querySelectorAll('.input__show-password').forEach(function (elem) {
  elem.addEventListener('click', function () {
    let input = elem.closest('.input').querySelector('.input__field');
    console.log('type : ', input.getAttribute('type'));
    if (input.getAttribute('type') == "password") {
      input.setAttribute('type', 'text');
    } else if (input.getAttribute('type') == "text") {
      input.setAttribute('type', 'password');
    }
  });
});

// Scroll to the newsletter footer section when submited
document.addEventListener("DOMContentLoaded", event => {
  let newsletterSectionRect = document.querySelector('.shopify-section--footer-newsletter').getBoundingClientRect();
  let windowHeight = window.innerHeight;
  let html = document.querySelector('html');
  let body = document.querySelector('body');
  html.style.scrollBehavior = "initial";
  body.style.scrollBehavior = "initial";
  if (!window.location.href.includes('#popup-newsletter-form')) {
    if (window.location.search.includes('form_type=customer') || window.location.search == "?customer_posted=true") {
      let scrollValueNLSection = newsletterSectionRect.top;
      window.scroll(0, scrollValueNLSection - windowHeight / 7);
    }
  }
  if (window.location.search.includes('form_type=customer') && document.querySelector('.input__field').value.length > 0) {
    console.log("le mail est déjà inscrit");
    document.querySelector('.form__custom-error').classList.add('active');
  }
  html.style.scrollBehavior = null;
  body.style.scrollBehavior = null;
});
if (window.location.href.includes('challenge#')) {
  window.location.href = window.location.origin + "/challenge";
}

// Update the language of the website if the navigator language is supported on the website 
function updateLocalization(language) {
  const formId = crypto.randomUUID();
  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="language_code" value="${language}">
    </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);

  // Submit the form with the updated language
  document.getElementById(formId).submit();
}
;

// If the language is not already initialized (avoids the case where if a language is initialized and then the language selector is used, the language is overwritten by the code above).
if (!sessionStorage.getItem('languageInitialized')) {
  // Initialize the language and downcase the country value
  let currentLanguage;
  let currentCountry = window.country.currentCountry.toLowerCase();

  // Check for country (US or GB or IT)
  if (currentCountry == 'gb' || currentCountry == "us") {
    currentLanguage = 'en';
  } else if (currentCountry == 'it') {
    currentLanguage = 'it';
  }
  ;

  // If the country iso code is gb, usa or it we change the language of the website 
  if (currentCountry == 'gb' || currentCountry == "us" || currentCountry == 'it') {
    updateLocalization(language = currentLanguage);
  }
  ;

  // Set the item
  sessionStorage.setItem('languageInitialized', 'true');
}
;

// Function for opening the Shopify chat after 5 seconds delay
function openShopifyChat() {
  if (sessionStorage.getItem('chatOpened')) return;
  const shopifyChat = document.querySelector("#ShopifyChat");
  if (shopifyChat) {
    const chatToggle = shopifyChat.shadowRoot.querySelector(".chat-toggle");
    chatToggle.click();
    sessionStorage.setItem('chatOpened', 'true');
  }
}
if (window.matchMedia('(min-width: 768px)').matches) {
  setTimeout(openShopifyChat, 5000);
}